<template>
    <div class="sa-list-component">
        <b-form>
            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Presidio:</label>
                    <b-form-select v-model="filtro.codicePresidio" :options="presidioOptions" value-field="value"
                        text-field="text" :value="null" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">Descrizione Prestazione:</label>
                    <b-form-input v-model="filtro.descrizione" type="search" id="descrizionePrestazione"
                        placeholder="Prestazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <label class="sa-label-data">Codice Prestazione:</label>
                    <b-form-input v-model="filtro.codice" type="search" id="descrizionePrestazione"
                        placeholder="Prestazione"></b-form-input>
                </b-col>
            </b-row>
            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                    <b-button @click="onSubmit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                    <b-button type="reset" v-on:click="onReset" variant="danger">{{
                        this.$i18n.t("patients.lblResetFilter") }}</b-button>
                </b-col>
            </b-row>
        </b-form>
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                    :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light"
                    class="sa-b-table">
                    <template v-slot:cell(codice)="{ item }">
                        <span style="width: 100%; display: inline-block;">{{ item.descrizione }}</span>
                        <small>{{ item.codice }}</small>
                    </template>
                    <template v-slot:cell(codicePresidio)="{ item }">
                        <span> {{ getDescrizionePresidioStruttura(item) }}</span>
                    </template>
                    <template v-slot:cell(note)="{ item }">
                        <span>{{ item.note }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-secondary"
                                title="Modifica Prestazione" @click="onEdit(row.item, row.index, $event.target)"
                                class="mr-1 no-text">
                                <b-icon icon="pencil" variant="outline-secondary"></b-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Elimina Prestazione"
                                @click="onElimina(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <b-icon icon="trash" variant="outline-secondary"></b-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import toast from "../../../../template/layout/utility/sa-toast";

export default {

    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage.getItem("filtroPresidiPrestazioni")) {
            me.filtro = JSON.parse(sessionStorage.getItem("filtroPresidiPrestazioni"));
        }
        this.loadCodPresidi();

    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/ricettaprestazionipresidio",
            pathResourcePresidi: "/utentipresidi",
            filtro: { codicePresidio: null, descrizione: null, codice: null },
            items: [],
            presidioOptions: [],
            listaPresidi: [],
            listKey: 0,
            fields: [
                {
                    label: "Prestazione",
                    key: "codice",
                    sortable: true,
                },
                {
                    label: "Struttura/Presidio",
                    key: "codicePresidio",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.items = [];
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadCodPresidi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/users/profile";
            axios
                .get(link)
                .then((response) => {
                    me.utente = response.data.data;
                    me.user = me.utente;
                    me.nominativoUtente = me.utente.lastname + " " + me.utente.firstname;
                    me.ruolo = me.utente.profilo;
                    me.loadUtentiPresidi(me.utente.id);
                })
                .catch((e) => {
                    console.log(e);
                });

        },
        getDescrizionePresidioStruttura(item) {
            let returnValue = "";

            let presidio = this.listaPresidi.find(e => e.codicePresidio == item.codicePresidio)
            if (presidio) {
                returnValue = `${presidio.denominazionePresidio} (${presidio.denominazioneStruttura})`
            } else {
                returnValue = item.codicePresidio
            }
            return returnValue
        },
        loadUtentiPresidi(id) {
            let me = this;
            me.presidioOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            axios
                .get(link, { params: { idUtente: id, page: 1, forPage: 1000 } })
                .then((response) => {
                    me.listaPresidi = response.data.data.list;
                    me.listaPresidi.forEach((element) => {
                        me.presidioOptions.push({
                            value: element.codicePresidio,
                            text: element.denominazionePresidio + " (" + element.denominazioneStruttura + ")",
                        });
                    });
                    me.presidioOptions.unshift({
                        value: null,
                        text: "-Seleziona Presidio-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },


        onEdit(item) {
            let me = this;
            me.$router.push("/presidiprestazioni/edit/" + item.id);
        },
        onElimina(item) {
            this.$bvModal
                .msgBoxConfirm("Sei sicuro di voler eliminare questo appuntamento ?", {
                    title: "Eliminazione Appuntamento schedulato",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.eliminaPrestazione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        eliminaPrestazione(item) {
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + item.id;
            axios.delete(link).then(() => {
                toast.success("Eliminato con successo !")
                this.loadData();
            });

        },
        onReset() {
            let me = this;
            me.filtro = { idPresidio: null, descrizionePrestazione: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroPresidiPrestazioni", JSON.stringify(me.filtro));
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroPresidiPrestazioni", JSON.stringify(me.filtro));
            me.loadData();
        },
    },
};
</script>

<style lang="scss" scoped></style>
